var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.01948 3.92653C0.389724 4.28076 0 4.94713 0 5.66968V12.3303C0 13.0528 0.389724 13.7192 1.01948 14.0734L7.01948 17.4484C7.6283 17.7909 8.3717 17.7909 8.98052 17.4484L14.9805 14.0734C15.6103 13.7192 16 13.0528 16 12.3303V5.66968C16 4.94713 15.6103 4.28076 14.9805 3.92653L8.98052 0.551527C8.3717 0.209061 7.6283 0.209062 7.01948 0.551527L1.01948 3.92653ZM6 8.99998C6 7.89541 6.89543 6.99998 8 6.99998C9.10457 6.99998 10 7.89541 10 8.99998C10 10.1046 9.10457 11 8 11C6.89543 11 6 10.1046 6 8.99998ZM8 4.99998C5.79086 4.99998 4 6.79084 4 8.99998C4 11.2091 5.79086 13 8 13C10.2091 13 12 11.2091 12 8.99998C12 6.79084 10.2091 4.99998 8 4.99998Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.011d8cfe090eff56abc7168e7024001f.svg";
export { ForwardRef as ReactComponent };